import http from '@/utils/http-common'
import { showCustomSwalToast } from '@/utils/customSwalToast.mjs'
import router from '@/router'
import { refreshAccessTokenAsMethodRecall } from '@/utils/auth-service'
import { WORK_ACTION_MODE_PREFERENCE_KEY } from '@/views/WorkManagement/work-ui-ab-policy.mjs'

function methodRecall() { // main.js, mutations.js, actions.js, index.js(router) 공유
  return refreshAccessTokenAsMethodRecall();
}

const userPreferenceSaves = new WeakMap()

function serializeUserPreferenceSave(user, save) {
  const previous = userPreferenceSaves.get(user)
  const operation = previous ? previous.then(save, save) : save()
  userPreferenceSaves.set(user, operation)
  return operation.finally(() => {
    if (userPreferenceSaves.get(user) === operation) userPreferenceSaves.delete(user)
  })
}

export default {
  async saveWorkActionMode({ state, commit }, mode) {
    const user = state.user_info
    const userId = user?.pk || user?.id
    if (!userId || !['a', 'b'].includes(mode)) throw new Error('Invalid work action preference')

    return serializeUserPreferenceSave(user, async () => {
      if (state.user_info !== user) return
      const response = await http.put(`account/user/${userId}/`, {
        sort_json: { ...(user.sort_json || {}), [WORK_ACTION_MODE_PREFERENCE_KEY]: mode },
      }, { suppressGlobalErrorToast: true })

      // A response from a previous login must not update the current user's settings.
      if (state.user_info !== user) return
      if (response.data?.sort_json?.[WORK_ACTION_MODE_PREFERENCE_KEY] !== mode) {
        throw new Error('Work action preference was not confirmed')
      }
      commit('SET_USER_SORT_VALUE', { key: WORK_ACTION_MODE_PREFERENCE_KEY, value: mode })
    })
  },
  // user_info 전체를 갱신하고 서버에 저장
  async updateUserInfo({ commit, dispatch }, payload) {
    console.log('updateUserInfo', payload)
    commit('SET_USER_INFO', payload)
    await dispatch('syncUserSortJsonToServer')
  },
  // sort_json 특정 값만 변경하고 서버에 저장 (가장 자주 쓸 것)
  async updateUserSortValue({ commit, dispatch }, { key, value }) {
    console.log('updateUserSortValue', { key, value })
    commit('SET_USER_SORT_VALUE', { key, value })
    await dispatch('syncUserSortJsonToServer')
  },
  // sort_json 저장
  async syncUserSortJsonToServer({ state, commit }) {
    const user = state.user_info
    if (!user) return
    return serializeUserPreferenceSave(user, async () => {
      if (state.user_info !== user) return
      console.log('syncUserSortJsonToServer')
      // 토큰 없으면 로그아웃 + 이동
      if (!state.access_token) {
        console.log('토큰 없으면 로그아웃 + 이동')
        commit('logout')
        router.push('/').catch(() => {})
        return
      }

      const userId = state.user_info?.pk || state.user_info?.id
      if (!userId) {
        console.log('userId 없음')
        return
      }

      const body = { sort_json: { ...(state.user_info?.sort_json || {}) } }
      console.log('syncUserSortJsonToServer body', body)
      const makeHeaders = () => ({ Authorization: 'Bearer ' + state.access_token })

      try {
        await http.put(`account/user/${userId}/`, body, { headers: makeHeaders() })
      } catch (err) {
        if (state.user_info !== user) return
        if ((err?.response?.status !== 401 || err.authRetryExhausted)) throw err

        // access token 만료 → recall 후 재시도
        try {
          const msg = await methodRecall()
          if (state.user_info !== user) return
          console.log(msg)
          // methodRecall 내부에서 state.access_token 갱신된다고 가정(기존 로직 그대로)
          await http.put(`account/user/${userId}/`, body, { headers: makeHeaders() })
        } catch (err_msg) {
          if (state.user_info !== user) return
          if (err_msg === 0) {
            // BE에 access token 저장 실패
            console.log('BE에 access token 저장 실패')
            return
          }

          // refresh token 만료
          showCustomSwalToast({ text: '다시 로그인해 주세요.' })

          commit('logout')
          router.push('/').catch(() => {})
        }
      }
    })
  },
}
